import script from "./RedirectCalendly.vue?vue&type=script&setup=true&lang=js"
export * from "./RedirectCalendly.vue?vue&type=script&setup=true&lang=js"

import "./RedirectCalendly.vue?vue&type=style&index=0&id=1051c06a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1051c06a"]])

export default __exports__